import { Vorgang } from '../types';

export function pruefeReparaturkostenAbweichung(vorgang: Vorgang): boolean {
  const reparaturkosten = vorgang?.bewertung?.reparaturkosten;
  const datReparaturkosten = vorgang?.dat?.reparaturkostenBrutto;
  return Boolean(datReparaturkosten) && Boolean(reparaturkosten) && Number(datReparaturkosten) !== Number(reparaturkosten);
}
